import "./libs/locale/i18n";

import SplashScreen from "components/organisms/SplashScreen";
import ErrorFallback from "components/wrapped/ErrorFallback";
import { getConfig } from "libs/api/configs";
import { appInsights, setAppInsightsConnectionString, } from "libs/app-insights";
import { handlerOnError } from "libs/error";
import { Suspense } from "react";
import ReactDOM from "react-dom";
import { ErrorBoundary } from "react-error-boundary";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import GlobalStyle from "styles/GlobalStyle";

import { name, version } from "../package.json";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

console.log(`${name}@${version}`);

const rootElement = document.getElementById("root");
const nodeEnv = process.env.NODE_ENV;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
      // 개발 환경에서는 디버깅을 빠르게 하기 위해서 재시도하지 않도록 함
      retry: nodeEnv === "development" ? 0 : undefined,
    },
  },
});

ReactDOM.render(
  <>
    {/* prettier-ignore */}
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ErrorBoundary FallbackComponent={({ error }) => <h3>{error.message ? error.message : "앱 실행 중 에러 발생"}</h3>}>
            <Suspense fallback={<>{/* <SplashScreen /> 에서 Teams Init과 같은 앱의 기본적인 비동기 작업 수행을 위한 fallback */}</>}>
              <ErrorBoundary FallbackComponent={ErrorFallback} onError={handlerOnError}>
                <Suspense fallback={<SplashScreen  />}>
                  <App />
                </Suspense>
              </ErrorBoundary>
            </Suspense>
          </ErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </RecoilRoot>
    <GlobalStyle />
  </>,
  rootElement
);

reportWebVitals(async (metric) => {
  // 사실 메트릭을 전송하는 시점에 app Insight가 초기화되지 않았을 확률이 매우 낮습니다.
  // react app 시작하자마자 app Insight를 초기화하도록 코딩했기 때문.
  // 그래도 혹시 모르니 방어적으로 코딩했습니다.
  if (!appInsights.config.connectionString) {
    try {
      const config = await getConfig();
      setAppInsightsConnectionString(config.appInsightsConnectionString);
      appInsights.trackTrace({
        message: "react app보다 FCP가 먼저 완료되어 Web Vitals에서 App Insight가 init되었습니다.",
      });
    } catch (error) {
      const newDiv = document.createElement("div");

      const title = document.createElement("h3");
      title.innerText = "앱이 시작 중 문제가 발생하였습니다.";
      newDiv.appendChild(title);

      const errorMessage = document.createElement("span");
      errorMessage.innerText = (error as Error).message;
      newDiv.appendChild(errorMessage);

      document.body.insertBefore(newDiv, rootElement);
      console.error(error);
      return;
    }
  }

  // TODO: TTI 측정 기능 재검토
  // if (metric.name === "FCP") {
  //   startTTI();
  // }

  console.log(`${metric.name}: ${metric.value}`);

  appInsights.trackEvent({
    name: metric.name,
    properties: {
      Href: window.location.href,
      Pathname: window.location.pathname,
      Search: window.location.search,
      Duration: metric.value,
      Delta: metric.delta,
      MetricId: metric.id,
      MetricEntries: {
        ...metric.entries,
      },
    },
  });
});
